import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_INTERNAL_PARCELS,
  GET_INTERNAL_PARCELS,
  CLEAR_INTERNAL_PARCEL,
  FLAG_INTERNAL_PARCEL_ACTIVITY,
  GET_INTERNAL_PARCEL,
  CLEAR_INTERNAL_PARCELS,
} from '../../../actions/types/cargo';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    price: Immutable.Set(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_INTERNAL_PARCELS:
      return state.setIn(['all', 'loading'], payload);
    case GET_INTERNAL_PARCELS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_INTERNAL_PARCELS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_INTERNAL_PARCEL_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_INTERNAL_PARCEL:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_INTERNAL_PARCEL:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
